
<script>
import BarList from '../components/bar-list'
import NatesForm from './nates-form'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codnates: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            tabs: [
                { title: 'Saída', icon: '' },
                { title: 'Entrada', icon: '' },
            ],

            activeTab: 0,
        }
    },

    computed: {
        natesList: function () {
            return this.$store.getters.getNatesList
        },
        natesListSaida: function () {
            return this.$store.getters.getNatesSaidaList
        },
        natesListEntrada: function () {
            return this.$store.getters.getNatesEntradaList
        },

        tabSaida: function () {
            return this.activeTab == 0
        },

        tabEntrada: function () {
            return this.activeTab == 1
        },
   },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },

    },

    methods: {

        changeTab (idx) {
            this.activeTab = idx
        },

        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codnates = cod
            this.showForm = true;
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codnates = ''
            this.showForm = true;
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"cfop":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
          this.$store.dispatch('loadNates', { filter: this.filter } )
        },

        textStatus(val) {
          if (val === 'A') return 'Ativo';
          if (val === 'I') return 'Inativo';
          return val;
        }

    },

    components: {
        BarList, NatesForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Natureza"
                plural-entity="Naturezas"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo CFOP ou pela descrição">
            </bar-list>
            <br>

            <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

            <br>
            <div class="default-container nb-card-list">
                <alert v-if="(tabSaida && (!natesListSaida || natesListSaida.length == 0)) || (tabEntrada && (!natesListEntrada || natesListEntrada.length == 0))" type="norecord"></alert>

                <!-- Saída -->
                <article v-if="tabSaida" class="nb-card" v-for="nates in natesListSaida" :key="nates.codnates">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ nates.descricao }}</h2>
                                    <span v-if="nates.stnates" class="nb-card-badge" :class="nates.stnates == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'">
                                        {{ textStatus(nates.stnates) }}
                                    </span>
                                </div>
                                <div class="nb-card-code">
                                    CFOP <strong>{{ nates.cfop }}</strong>
                                    <span v-if="nates.codnates" class="ml-2">Código <strong>{{ nates.codnates }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                v-on:edit="handleEdit(nates.codnates)"
                                v-on:view="handleEdit(nates.codnates, true)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="metadata && metadata.nates && metadata.nates.tpnat">
                            <span class="nb-card-detail-label">{{ metadata.nates.tpnat.label }}</span>
                            <strong>{{ nates.tpnat | getText(metadata.nates.tpnat) }}</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.nates && metadata.nates.tpnf">
                            <span class="nb-card-detail-label">{{ metadata.nates.tpnf.label }}</span>
                            <strong>{{ nates.tpnf | getText(metadata.nates.tpnf) }}</strong>
                        </div>
                    </div>
                </article>

                <!-- Entrada -->
                <article v-if="tabEntrada" class="nb-card" v-for="nates in natesListEntrada" :key="nates.codnates">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ nates.descricao }}</h2>
                                    <span v-if="nates.stnates" class="nb-card-badge" :class="nates.stnates == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'">
                                        {{ textStatus(nates.stnates) }}
                                    </span>
                                </div>
                                <div class="nb-card-code">
                                    CFOP <strong>{{ nates.cfop }}</strong>
                                    <span v-if="nates.codnates" class="ml-2">Código <strong>{{ nates.codnates }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                v-on:edit="handleEdit(nates.codnates)"
                                v-on:view="handleEdit(nates.codnates, true)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="metadata && metadata.nates && metadata.nates.tpnat">
                            <span class="nb-card-detail-label">{{ metadata.nates.tpnat.label }}</span>
                            <strong>{{ nates.tpnat | getText(metadata.nates.tpnat) }}</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.nates && metadata.nates.tpnf">
                            <span class="nb-card-detail-label">{{ metadata.nates.tpnf.label }}</span>
                            <strong>{{ nates.tpnf | getText(metadata.nates.tpnf) }}</strong>
                        </div>
                    </div>
                </article>
            </div>

        </div>
        <nates-form v-if="showForm" :index="this.codnates" :crud="this.crud" v-on:closeform="closeForm"></nates-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/nates-list.vue